module.exports = __webpack_public_path__ + "img/material.2bac07a8.svg";